export const VIEW_RECEIVED_MESSAGES = 'VIEW_RECEIVED_MESSAGES';
